import resetScroll from '../../utils/scripts/resetScroll';
import initialState from './state';
import { getScreenFlow } from '../../utils/scripts/getScreenFlow';
import { getParameterFromURL } from '../../utils/scripts';

import {
  SHOW_PAYMENT_POPUP,
  HIDE_PAYMENT_POPUP,
  PAYMENT_MODAL_SHOW,
  PAYMENT_MODAL_HIDE,
  TOGGLE_LOADER,
  SHOW_CHANGE_MAIL_SCREEN,
  SET_EXPAND_VIEW_FOR_STRIPE,
  UPDATE_PURCHASE_FLOW,
  SHOW_SPECIAL_OFFER,
  TOGGLE_MODAL_DISCOUNT,
  MARK_DISCOUNT_SHOWN,
} from './actions';
import { analyticsEventsTracker, GTMOnboardingFunnelEvent, EVENT_TRACKERS } from '../../utils/analytics';
import getCurrencyValue from '../../utils/scripts/getCurrencyValue';
import getProductDuration from '../../utils/scripts/getProductDuration';

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_EXPAND_VIEW_FOR_STRIPE:
      return {
        ...state,
        expandViewStripe: action.payload,
      };

    case SHOW_PAYMENT_POPUP:
      document.querySelector('html').classList.add('disableScroll');
      setTimeout(resetScroll, 200);
      return {
        ...state,
        showPaymentPopup: true,
      };

    case HIDE_PAYMENT_POPUP:
      document.querySelector('html').classList.remove('disableScroll');
      return {
        ...state,
        showPaymentPopup: false,
      };

    case PAYMENT_MODAL_SHOW:
      document.querySelector('html').classList.add('disableScroll');
      const { product = '', currency = '$', price = null } = action.payload || {};
      const currencyISO = getCurrencyValue();
      analyticsEventsTracker.trackWithTarget(
        GTMOnboardingFunnelEvent.showPayment(product, currencyISO, price, getProductDuration(product)),
        EVENT_TRACKERS.GTM
      );

      analyticsEventsTracker.trackWithTarget(
        GTMOnboardingFunnelEvent.addToCart(product, currencyISO, price),
        EVENT_TRACKERS.GTM
      );

      setTimeout(() => {
        window.scrollTo(0, -350);
      }, 200);

      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 250);

      return {
        ...state,
        paymentModal: {
          ...state.paymentModal,
          show: true,
        },
      };

    case PAYMENT_MODAL_HIDE:
      document.querySelector('html').classList.remove('disableScroll');
      return {
        ...state,
        paymentModal: {
          ...state.paymentModal,
          show: false,
        },
      };

    case TOGGLE_LOADER:
      return {
        ...state,
        showLoader: action.payload,
      };

    case SHOW_CHANGE_MAIL_SCREEN:
      return {
        ...state,
        showChangeMailScreen: action.payload,
      };

    case UPDATE_PURCHASE_FLOW: {
      window.scrollTo({ top: 0 });
      if (!document.querySelector('html').classList.contains('disableScroll')) {
        document.querySelector('html').classList.add('disableScroll');
      }

      const {
        email = state.purchaseFlowScreen.email,
        url = state.purchaseFlowScreen.url,
        payment_system = state.purchaseFlowScreen.payment_system,
        upselPDF = state.purchaseFlowScreen.upselPDF,
        screenFlow: customScreenFlow,
        startFromScreen,
      } = action.payload;
      // const screenFlow = testChat ? getScreenFlow() : state.purchaseFlowScreen.screenFlow;

      const screenFlow = customScreenFlow || getScreenFlow() || state.purchaseFlowScreen.screenFlow;

      let nextScreen = '';
      let currentScreenIndex = state.purchaseFlowScreen.currentScreenIndex + 1;

      if (startFromScreen) {
        const startIndex = screenFlow.indexOf(startFromScreen);
        const normalizedStartIndex = startIndex >= 0 ? startIndex : 0;
        nextScreen = screenFlow[normalizedStartIndex] || '';
        currentScreenIndex = normalizedStartIndex + 1;
      } else {
        nextScreen = screenFlow[state.purchaseFlowScreen.currentScreenIndex] || '';
      }

      return {
        ...state,
        paymentModal: {
          show: false,
        },
        purchaseFlowScreen: {
          email,
          url,
          payment_system,
          showPDFUpselling: nextScreen === 'PDFUpselling',
          showChatUpsale: nextScreen === 'ChatUpsale',
          showFakeHardwar: nextScreen === 'FakeHardwar',
          showSupplementsUpsale: nextScreen === 'SupplementsUpsale',
          showSuccessScreen: nextScreen === 'SuccessScreen',
          screenFlow,
          currentScreenIndex,
          upselPDF,
        },
      };
    }

    case SHOW_SPECIAL_OFFER:
      window.showSpecialOffer = true;
      return {
        ...state,
        showSpecialOffer: true,
      };

    case TOGGLE_MODAL_DISCOUNT: {
      return { ...state, showModalDiscount: !state.showModalDiscount };
    }

    case MARK_DISCOUNT_SHOWN:
      return { ...state, discountShownOnce: true };

    default:
      return state;
  }
}

export default reducer;
